export enum Role {
  ADMIN = 'ADMIN',
  AUTHOR = 'AUTHOR',
  BHT_CONSULTANT = 'BHT-CONSULTANT',
  SINGLE_ACCESS = 'SINGLE-ACCESS',
}
